import { render, staticRenderFns } from "./AccountDropdown.vue?vue&type=template&id=3079b17e&"
import script from "./AccountDropdown.vue?vue&type=script&lang=js&"
export * from "./AccountDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AccountDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports